import { render, staticRenderFns } from "./4.vue?vue&type=template&id=2ae9e8ba&scoped=true&"
var script = {}
import style0 from "./4.vue?vue&type=style&index=0&id=2ae9e8ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae9e8ba",
  null
  
)

export default component.exports